<template>
  <div class="news_msg">
    <div class="back-img"></div>
    <div class="title">
      <el-row :gutter="20">
        <el-col
          :class="{ active: index === isActive }"
          :key="index"
          :span="8"
          @click.native="handleClick(index, item.id)"
          v-for="(item, index) in navData"
          >{{ item.value }}</el-col
        >
      </el-row>
    </div>

    <div class="main">
      <el-row :gutter="20">
        <el-col
          :key="o.id"
          :span="6"
          @click.native="handleMsg(o.id)"
          v-for="o in dataList"
          v-loading="loading"
        >
          <el-card :body-style="{ padding: '0px' }">
            <img alt class="icon" src="@image/check.png" />
            <div class="bottom">
              <!-- <div class="time">
                <span class="date">{{
                  o.issue_time | dateFormat('MM.DD')
                }}</span>
                <span class="year">{{ o.issue_year }}</span>
              </div>-->
              <p class="two-ell">{{ o.title }}</p>
              <div class="time">
                {{ o.issue_time | dateFormat('YYYY-MM-DD') }}
              </div>
            </div>
            <img :alt="o.title" :src="o.cover" class="image" />
          </el-card>
        </el-col>
      </el-row>

      <!-- <el-row :gutter="20">
        <el-col
          :span="6"
          v-for="o in 8"
          :key="o"
          @click.native="handleMsg(o.id)"
        >
          <el-card :body-style="{ padding: '0px' }">
            <img src="@image/check.png" alt="" class="icon" />
            <div class="bottom">
              <div class="time">
                <span class="date">1235</span>
                <span class="year">123456</span>
              </div>
              <p>123</p>
            </div>
            <img src="../../assets/image/news.png" class="image" />
          </el-card>
        </el-col>
      </el-row>-->
      <el-pagination
        :current-page="pagination.current"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        @current-change="handleCurrentChange"
        background
        layout="prev, pager, next"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
// import Qs from 'qs'
import { getNews } from '@/api/news'
export default {
  data() {
    return {
      navData: [
        { id: 1, value: '企业新闻' },
        { id: 2, value: '行业动态' },
        { id: 3, value: '伙伴频道' }
      ],
      isActive: 0,
      dataList: [],
      pagination: {
        total: 0,
        pageSize: 8,
        current: 1
      },
      numType: 1,
      loading: false,
      ylStatus: this.$store.getters.urlStatus
    }
  },
  watch: {
    $route: function(val) {
      this.routerName(val.query.routerPath)
      this.init()
    }
  },
  created() {
    this.routerName(this.$route.query.routerPath)
    this.init()
  },
  // mounted() {
  //   this.routerName(this.$route.query.routerPath)
  //   this.init()
  // },
  methods: {
    //新闻数据
    init() {
      const data = {
        cate_id: this.numType,
        page_no: this.pagination.current,
        page_size: this.pagination.pageSize
      }
      this.loading = true
      getNews(data)
        .then(res => {
          this.loading = false

          let list = res.data
          this.dataList = list.list
          this.pagination.total = list.page_total
          this.pagination.pageSize = Number(list.page_size)
          this.pagination.current = Number(list.page_no)
        })
        .catch(err => {
          console.log(err)
        })
      // this.$http.post('/getNewsList', data).then(res => {
      //   if (res.data.code) {
      //     let list = res.data.data
      //     this.dataList = list.list
      //     this.pagination.total = list.page_total
      //     this.pagination.pageSize = Number(list.page_size)
      //     this.pagination.current = Number(list.page_no)
      //   }
      // })
    },
    //查询
    handleClick(index, id) {
      this.isActive = index
      this.pagination.current = 1
      this.numType = id
      this.init()
    },
    //详情
    handleMsg(o) {
      this.$router.push({
        path: this.ylStatus ? 'newsMsg_yl' : '/newsMsg',
        query: { id: o }
      })
    },
    //分页
    handleCurrentChange(val) {
      this.pagination.current = val
      this.init()
    },
    //路由
    routerName(name) {
      switch (name) {
        case 'qyxw':
          this.isActive = 0
          this.numType = 1
          break
        case 'hydt':
          this.isActive = 1
          this.numType = 2
          break
        case 'hzxw':
          this.isActive = 2
          this.numType = 3
          break
      }
    }
  }
}
</script>

<style lang="scss" scope>
.news_msg {
  .back-img {
    background-image: url('../../assets/image/news-banner.png');
    margin-top: -105px;
  }
  .title {
    width: 65%;
    margin: auto;
    height: 70px;
    line-height: 70px;
    font-size: 24px;
    .el-row {
      margin-top: 80px;
      .el-col {
        // padding: 0px 250px;
        background: rgba(238, 241, 245, 1);
        color: #28303b;
        border-left: 15px solid #fff;
        border-right: 15px solid #fff;
        cursor: pointer;
        text-align: center;
      }
      .active {
        color: rgba(255, 255, 255, 1);
        background: rgba(13, 126, 248, 1);
        color: #fff;
      }
    }
  }
  .main {
    width: 65%;
    margin: 50px auto;
    .el-row {
      margin-left: 0;
      .el-col {
        cursor: pointer;
        position: relative;
        .icon {
          position: absolute;
          top: -22px;
          right: 10px;
          display: none;
        }
        .el-card {
          margin-bottom: 50px;
        }
        .el-card:hover {
          background: rgba(13, 126, 248, 1);
          span,
          p,
          .time {
            color: #fff;
          }
          .icon {
            display: block;
          }
          .two-ell {
            animation: bounce-in 0.5s;
          }
          // .image {
          //   animation: bounce-in 0.5s;
          // }
          @keyframes bounce-in {
            0% {
              transform: scale(0);
            }
            50% {
              transform: scale(1.15);
            }
            100% {
              transform: scale(1);
            }
          }
        }
      }
      .image {
        width: 100%;
        height: 120px;
        display: block;
      }
    }
  }

  .bottom {
    display: flex;
    flex-direction: column;
    padding: 30px 20px;
    height: 128px;
    position: relative;
    .time {
      position: absolute;
      bottom: 30px;
      left: 20px;
      color: #6e7175;
      // display: flex;
      // justify-content: space-between;
      span {
        color: #6e7175;
      }
      .date {
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(110, 113, 117, 1);
      }
      .year {
        margin-top: 15px;
      }
    }
    p {
      word-break: break-all;
      margin: 25px 0px;
      font-size: 17px;
      font-weight: 500;
      color: #6e7175;
      // font-weight: 600;
      // color: rgba(61, 66, 74, 1);
      text-align: start;
      text-align: initial;
    }
  }
  .el-pagination {
    text-align: center;
  }
}
</style>
